// coffee and water ratios in grams
export const COFFEE_WATER_RATIOS = [
  { coffee: 23, water: 200 },
  { coffee: 18, water: 250 },
  { coffee: 15, water: 250 },
  { coffee: 12, water: 200 },
];

export const GRIND_BREWTIME_RATIOS = [
  { grind: "fine", time: 60 },
  { grind: "medium", time: 90 },
  { grind: "coarse", time: 120 },
];

export const BLOOM_WATER_G = [0, 30, 60];
export const BLOOM_SECONDS = [20, 30, 40];
export const BREW_TEMP_C = [80, 85, 90, 95];
export const CLOCKWISE_STIR_TIMES = [0, 1, 2];
